import moment from "moment";
import 'moment-duration-format';

/**
 * Reference:
 * https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
 */
export function numberWithCommas(x) {
    if (!x) return 0;
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function removeParentheses(x) {
    return x.toString().replace(/\(.*\)/, '').trim();
}

export function formatDate(string) {
    if (!string) return;
    var options = {
        timeZone: "Africa/Cairo",
        hour12: true,
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    return new Date(string).toLocaleDateString([], options);
}

export function getDurationMonthDay(d1, d2) {
    d1 = moment(d1);
    d2 = moment(d2);
    const dur = moment.duration(d2.diff(d1));
    let format = 'M[m] D[d]';

    // if months and days = 0
    if (!dur.get('month') && !dur.get('day')) {
        format = 'H[h] m[ min]';
    } else 
    // if days and hours = 0
    if (!dur.get('day') && !dur.get('hour')) {
        format = 'm[ min] s[ sec]';
    }
    return dur.format(format);
}

export function monthDayYear(date) {
    return moment(date).format("MMM DD, YYYY")
}

export function fullDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm A")
}